import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
// hooks
import useAuth from '../hooks/useAuth'
// routes
import { PATH_DASHBOARD } from '../routes/paths'

// ----------------------------------------------------------------------

AdminGuard.propTypes = {
  children: PropTypes.node,
}

export default function AdminGuard({ children }) {
  const { user } = useAuth()

  if (!user?.is_superuser) {
    return <Navigate to={PATH_DASHBOARD.general.home} replace />
  }

  return <>{children}</>
}
